import '@vebox/etui-system';
import '../utilities/responsive.js';
import { Component, createRef, createElement } from 'react';
import { convertFormatToDateFns } from '../utilities/convertFormatToDateFns.js';
import { c as _defineProperty } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../H5/H5.js';
import '@vebox/etui-colors';
import { findDOMNode } from 'react-dom';
import 'react-spring/renderprops.cjs';
import '../Badge/Badge.js';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/ExtendedTooltip.js';
import { startOfDay, endOfDay } from 'date-fns';
import getWidth from 'dom-helpers/query/width';
import { eq } from 'date-arithmetic';
import { m as merge, g as getRange, a as diff } from '../dates-492a56eb.js';
import { W as WeekCalendarManageEventMode, G as GridColumn } from '../GridColumn-24289642.js';
import 'dom-helpers/util/scrollbarSize';
import GridHeader from './GridHeader.js';
import './utils/dataHelpers.js';
import { getDayEvents } from './utils/eventHelpers.js';
import './utils/getTimeSlots.js';
import 'lodash.sortby';
import './utils/getDisplayEvents.js';
import 'dom-helpers/query/contains';
import 'dom-helpers/query/closest';
import 'dom-helpers/events';
import './utils/domHelpers.js';
import '../GridSlotGroup-ad0bba3c.js';
import './TimeSelection.js';
import './Event.js';
import GridGutter from './GridGutter.js';
import { S as ScrollDiv, G as GridDiv, C as CalendarInfoBar, a as GridContentDiv } from '../CalendarInfoBar-a38381f9.js';

const raf = require('dom-helpers/util/requestAnimationFrame');
class WeekCalendar extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "scrollRef", /*#__PURE__*/createRef());
    _defineProperty(this, "contentRef", /*#__PURE__*/createRef());
    _defineProperty(this, "gutterRef", ref => {
      // eslint-disable-next-line react/no-find-dom-node
      this.gutter = ref && findDOMNode(ref);
    });
    _defineProperty(this, "handleScroll", e => {
      if (this.scrollRef.current) {
        this.scrollRef.current.scrollLeft = e.target.scrollLeft;
      }
    });
    _defineProperty(this, "handleResize", () => {
      raf.cancel(this.rafHandle);
      this.rafHandle = raf(this.checkOverflow);
    });
    _defineProperty(this, "handleSelectEvent", event => {
      if (this.props.onSelectEvent) {
        this.props.onSelectEvent(event);
      }
    });
    _defineProperty(this, "handleManageEvent", (event, mode) => {
      switch (mode) {
        case WeekCalendarManageEventMode.create:
          this.props.onCreateEvent(event);
          break;
        case WeekCalendarManageEventMode.edit:
          this.props.onEditEvent(event);
          break;
        case WeekCalendarManageEventMode.delete:
          this.props.onDeleteEvent(event);
          break;
      }
    });
    _defineProperty(this, "checkOverflow", () => {
      if (this.updatingOverflow) return;
      const content = this.contentRef.current;
      const isOverflowing = content.scrollHeight > content.clientHeight;
      if (this.state.isOverflowing !== isOverflowing) {
        this.updatingOverflow = true;
        this.setState({
          isOverflowing
        }, () => {
          this.updatingOverflow = false;
        });
      }
    });
    _defineProperty(this, "renderGridColumns", range => {
      const {
        min,
        max
      } = this.state;
      const {
        timeStep,
        isSelectable,
        isSingleTimeSelection,
        pressThreshold,
        timeFormat,
        events,
        weekDaysCount,
        isTodayDisabled,
        columnWidth
      } = this.props;
      const now = new Date();
      const dayColumns = range.slice(0, weekDaysCount);
      return dayColumns.map((date, index) => {
        const dayEvents = getDayEvents(date, events);
        return /*#__PURE__*/createElement(GridColumn, {
          key: index,
          min: merge(date, min),
          max: merge(date, max),
          columnWidth: columnWidth,
          timeStep: timeStep,
          isToday: eq(date, now, 'day'),
          isTodayDisabled: isTodayDisabled,
          isSelectable: isSelectable,
          pressThreshold: pressThreshold,
          events: dayEvents,
          onManageEvent: this.handleManageEvent,
          onSelectEvent: this.handleSelectEvent,
          timeFormat: convertFormatToDateFns(timeFormat),
          isSingleTimeSelection: isSingleTimeSelection,
          onNewEventRender: this.props.onNewEventRender
        });
      });
    });
    this.state = {
      range: getRange(props.date, props.firstDayOfWeek),
      min: startOfDay(new Date()),
      max: endOfDay(new Date()),
      gutterWidth: undefined,
      isOverflowing: null
    };
  }
  UNSAFE_componentWillMount() {
    this.calculateScroll();
  }
  componentDidMount() {
    this.checkOverflow();
    if (this.props.width == null) {
      this.measureGutter();
    }
    this.applyScroll();
    window.addEventListener('resize', this.handleResize);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.width == null) {
      this.measureGutter();
    }
    if (!eq(this.state.range[0], prevState.range[0], 'minute') || !eq(this.props.scrollToTime, prevProps.scrollToTime, 'minute')) {
      this.calculateScroll(this.props);
    }
    this.applyScroll();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    raf.cancel(this.rafHandle);
    if (this.measureGutterAnimationFrameRequest) {
      window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
    }
  }
  calculateScroll(props = this.props, state = this.state) {
    const {
      scrollToTime
    } = props;
    const {
      min,
      max
    } = state;
    const diffMillis = +scrollToTime - +startOfDay(scrollToTime);
    const totalMillis = diff(max, min);
    this.scrollRatio = diffMillis / totalMillis;
  }
  applyScroll() {
    if (this.scrollRatio) {
      const content = this.contentRef.current;
      content.scrollTop = content.scrollHeight * this.scrollRatio;
      // Only do this once
      this.scrollRatio = null;
    }
  }
  measureGutter() {
    if (this.measureGutterAnimationFrameRequest) {
      window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
    }
    this.measureGutterAnimationFrameRequest = window.requestAnimationFrame(() => {
      const width = getWidth(this.gutter);
      if (width && this.state.gutterWidth !== width) {
        this.setState({
          gutterWidth: width
        });
      }
    });
  }
  clearSelection() {
    clearTimeout(this.selectTimer);
  }
  render() {
    const {
      range,
      min,
      max,
      gutterWidth,
      isOverflowing
    } = this.state;
    const {
      timeStep,
      width,
      dayFormat,
      timeFormat,
      weekDaysCount,
      isHeaderVisible,
      isResponsive,
      calendarBar
    } = this.props;

    // const wrapperWidth = width || gutterWidth;
    const wrapperWidth = gutterWidth;
    const start = range[0];
    return /*#__PURE__*/createElement(ScrollDiv, {
      isResponsive: isResponsive,
      width: width,
      id: "calendar-container"
    }, /*#__PURE__*/createElement(GridDiv, {
      isResponsive: isResponsive
    }, calendarBar && /*#__PURE__*/createElement(CalendarInfoBar, {
      items: calendarBar
    }), isHeaderVisible && /*#__PURE__*/createElement(GridHeader, {
      range: range,
      width: wrapperWidth,
      scrollRef: this.scrollRef,
      isOverflowing: isOverflowing,
      dayFormat: dayFormat,
      weekDaysCount: weekDaysCount
    }), /*#__PURE__*/createElement(GridContentDiv, {
      ref: this.contentRef,
      onScroll: this.handleScroll
    }, /*#__PURE__*/createElement(GridGutter, {
      ref: this.gutterRef,
      min: merge(start, min),
      max: merge(start, max),
      timeStep: timeStep,
      timeFormat: convertFormatToDateFns(timeFormat)
    }), this.renderGridColumns(range))));
  }
}
_defineProperty(WeekCalendar, "defaultProps", {
  date: new Date(),
  isSelectable: false,
  timeStep: 10,
  scrollToTime: startOfDay(new Date()),
  pressThreshold: 250,
  dayFormat: 'EEEE',
  timeFormat: 'HH:mm',
  events: [],
  firstDayOfWeek: 1,
  isHeaderVisible: true,
  weekDaysCount: 7,
  isResponsive: false,
  isTodayDisabled: false,
  calendarBar: null
});

export default WeekCalendar;
